document.addEventListener('DOMContentLoaded', function() {
  const a_download = document.querySelector("a#download-pdf");
  if (a_download !== null) {
    a_download.addEventListener('click', async function(event) {
      console.log('click');
      const url = 'https://webhooks.mechanic.dev/2fd50e1e-939e-41b0-8ef7-271b75dc888c';
      const data = {
        receipt_id: event.target.dataset.receipt_id,
        vf_code: event.target.dataset.vf_code,
      };
  
      setTimeout(function() {
        fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })}, 5000);
    });
  }
});
